// extracted by mini-css-extract-plugin
module.exports = {"search":"search-icon_search__4Ht0X","search-icon":"search-icon_search-icon__Us0gK"};